<template>
    <v-dialog 
        v-model="$store.getters.overlays.login" 
        :max-width="tab == 0 ? `500`: `650`"
        :fullscreen="$store.getters.window.width<=800"
        persistent
        content-class="loginViewDialog"
        >

    <v-card> 
        <v-card-title :class="$style.loginViewWrapper">
            <v-spacer/>
                <img :src="VivomapLogo"/>
            <v-spacer/>

            <v-icon @click="close" color="black" :class="$style.loginCloseBtn">fa-times-circle</v-icon>
        </v-card-title>


        <v-tabs
            v-show="view=='main'"
            v-model="tab"
            color="#37a8ce"
            centered
            grow
            >
            <v-tabs-slider :class="$style.loginSlider"></v-tabs-slider>
            <v-tab  :key="0" :class="$style.loginTab">
                <str index="login > tab login" />
            </v-tab>
            <v-tab :key="1" :class="$style.registerTab">
                <str index="login > tab register" />
            </v-tab>

            <v-tabs-items v-model="tab" :class="$style.mainWrapper">
                <v-tab-item>
                    <SignIn
                        v-on:close="close"
                        v-on:forgot_password="view='forgotPassword'"
                        v-on:accountUnvalidatedFeed="accountUnvalidatedFeedHandler"
                        />
                </v-tab-item>

                <v-tab-item>
                    <Registration 
                        @close="close"
                        @site_regulation="siteRegulation"
                        @registration_result="PostActionFeed"
                        />
                </v-tab-item>
            </v-tabs-items>
        </v-tabs>


        <ForgotPassword 
            v-if="view=='forgotPassword'"
            v-on:back="view='main'"
            @close="close"
            />
            
        <SiteRegulation 
            v-if="view=='siteRegulation'"
            @close="close"
            />
            
        <PostActionFeed
            v-if="view=='postAction'"
            @close="close"
            :response="response"
            :failureActionButtonState="accountUnalidatedEmail!==null ? 'hide' : 'show'"
            />            

        <AccountUnvalidatedFeed
            v-if="view=='accountNotValidated'"
            @close="close"
            v-on:resend="accountSendValidation"            
            />
            
    </v-card>


    </v-dialog>


</template>

<script>
import VivomapLogo from '@/assets/images/logos/vivomap.png';
import SignIn from './signIn.vue';
import Registration from './registration.vue';
import ForgotPassword from './ForgotPassword.vue';
import SiteRegulation from '@/components/SiteRegulation/SiteRegulation.vue';
import PostActionFeed from '@/components/Login_Register/PostActionFeed.vue';
import AccountUnvalidatedFeed from '@/components/Login_Register/AccountUnvalidatedFeed.vue';

export default {
    name: "Login",
    components: {
        SignIn,
        Registration,
        ForgotPassword,
        SiteRegulation,
        PostActionFeed,
        AccountUnvalidatedFeed        
    },
    mounted: function(){
        this.setTab();
    },
    data: function(){
        return {
            tab: null,
            view: 'main',
            siteRegulationTargetTab: 0,
            response: null,
            accountUnalidatedEmail: null
        }
    },
    methods: {
        setTab: function(){
            switch(this.$route.name){
                default:
                    this.tab=0;
                break;

                case"register":                  
                    this.tab=1;
                break;
            }
        },
        close: function(param){
            this.accountUnalidatedEmail = null;
            if (this.view == 'siteRegulation' || (this.view == 'postAction' && param !== undefined && param == 'register' )) {
                this.view = 'main';
                this.tab = 1;
                return;
            }
            this.view = 'main';
            this.tab=0;
            this.$emit('close');
        },
        siteRegulation: function(target){
            this.$store.dispatch('siteRegulationTargetTab', target);            
            this.view='siteRegulation';
        },
        PostActionFeed: function(response){
            this.view='postAction';
            this.response = response;
        },
        accountUnvalidatedFeedHandler: function(account){
            this.view='accountNotValidated';
            this.accountUnalidatedEmail = account;
        },
        accountSendValidation: function() {
            var self = this;
            if(self.$store.getters.busy==0){
                self.$controller.security.user.sendAccountValidationLink(self.accountUnalidatedEmail).then(function(response){
                    setTimeout(function(){
                        self.view='postAction';
                        self.response = response;
                    },200);
                });
            }
            
            return;
        }        
    },
    computed: {
        route: function(){
            return this.$route.name;
        },
        VivomapLogo: function(){
            return VivomapLogo;
        }
    },
    watch:{
        route: function(){
            this.setTab();
        }, 
        '$store.getters.overlays.login': function(after, before) {
            if(after && (after != before)) {
                document.getElementsByTagName("body")[0].className="noscroll";
                document.getElementsByTagName("html")[0].className="noscroll";
            } else {
                document.body.removeAttribute("class","noscroll");
                document.getElementsByTagName("html")[0].classList.remove("noscroll");
            }
        },
        tab: function(after, before){
            if (after!==before && after==1){
                /*
                console.log(this.$options.name);
                console.log(this.$options.parent.$options.name);
                console.log(this.$controller.view.login)
                */
                this.$controller.gtmHandler.DataLayerHandler.pushEvent({
                    category: 'Initiated from:: '+this.$controller.view.login.referrer,
                    event_assoc_value: 1
                });
            }
        }
    }
}
</script>

<style module>
.loginViewWrapper img{
    max-height: 100px;
    margin-top:4%;
}

.loginViewWrapper {
    position: relative;
}
    .loginCloseBtn {
        position: absolute;
        right: 4.5%;
        top: 15%;
    }

.loginTab, .registerTab {
    font-size: 17pt !important;
    font-weight: 400 ;
    text-transform: initial !important;
}

.loginSlider {
    margin-top: 10px;
}

.mainWrapper{
    max-height: 700px;
    overflow-y: auto;
}

.mainWrapper::-webkit-scrollbar {
    width: 0.8em;
}

.mainWrapper::-webkit-scrollbar-track {
    box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
    border-radius: 5px;
}

.mainWrapper::-webkit-scrollbar-thumb {
    background-color: #d7d7d7;
    outline: 1px solid slategrey;
    border-radius: 5px;
}

@media screen and (max-height: 650px){
    .mainWrapper {
        max-height: 350px;
    }
}

@media screen and (min-height: 650px) and (max-height: 735px){
    .mainWrapper {
        max-height: 450px;
    }
}

@media screen and (min-height: 736px) and (max-height: 811px)  {
    .mainWrapper {
        max-height: 520px;
    }
}

@media screen and (min-height: 812px) and (max-height: 968px) {
    .mainWrapper {
        max-height: 600px;
    }
}

</style>

<style>
.v-tabs-bar__content{
    max-width: 360px !important;
    margin: auto;
}

.loginViewDialog {
    border-radius: 25px !important;
    overflow-y: hidden !important;
}

.noscroll {
    overflow-x: hidden;
    overflow-y: hidden;
}
</style>